<style scoped>
  /* @import "../../styles/common/common.less"; */
  /* @import "../../styles/common/List.less";  */
  
  .el-tag {
    height: 20px !important;
    padding: 0 5px !important;
    line-height: 19px !important;
  }
  
  .ivu-icon-arrow-shrink,
  .ivu-icon-arrow-expand,
  .ivu-icon-android-close {
    font-size: 20px;
    color: #999;
    transition: color 0.2s ease;
    position: relative;
    top: 0px;
    margin-left: 10px;
  }
  
  .ivu-icon-arrow-shrink:hover {
    color: #444;
  }
  
  .ivu-icon-arrow-expand:hover {
    color: #444;
  }
  
  .ivu-icon-android-close:hover {
    color: #444;
  }
  .search-plus-collapse {
    margin-bottom: 12px;
    justify-content: space-around;
  
  }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    
    <div class="list-content-div ">
      <div class="list-header-title-div">电表记录</div>
      <!-- 上上月、上月、本月 电量 -->
      <div style="width: 100%; display: flex;align-items: center;justify-content: space-around;margin: 24px 0;">
        <div v-for="(item, index) in monthList" :key="index" style="width: calc(100% / 3); font-size: 14px; color: #333;">
          <span style="color: #999;">{{ item.chargeMonth }} ：</span>
          <span>{{ item.chargeVal }} 度</span>
        </div>
      </div>
      
      <el-tabs v-model="editableTabsValue" type="card" @tab-click="tabFlag" :before-leave="beforeLeave">
        <el-tab-pane v-for="item in editableTabs" :key="item.elecNo" :label="item.elecName">
          <span slot="label">
            <span>{{ item.elecName }}</span>
<!--            <span style="margin-left: 16px" v-if="elecNo == item.elecNo" @click="editTabs"><i class="el-icon-edit"></i></span>-->
          </span>
        </el-tab-pane>
        <el-tab-pane key="add" name="add">
          <span slot="label" style="padding: 8px;font-size:20px;font-weight:bold;">+</span>
        </el-tab-pane>
      </el-tabs>
      
      <!-- 查询 -->
      <ZD-list-querys>
          <template slot="inputs">
            <div class="list-query-child-div flex">
              <div class="query-title-div">选择自然月</div>
              <div class="query-inputs-div flex-1">
                <el-date-picker value-format="yyyy-MM" v-model="queryInfo.yearMon"
                    :picker-options="pickerOptions" type="month" placeholder="请选择自然月"
                    size="small" style="width: 100%">
                </el-date-picker>
              </div>
            </div>
          </template>
          <template slot="actions">
            <button class="common-bg-button" @click="initList(pagination, true)">搜 索</button>
            <button class="common-empty-button" @click="resetList">重 置</button>
          </template>
      </ZD-list-querys>
      
      <div class="page-action-btns flex">
        <div>
          <button class="common-bg-button" @click="listAddFun()">新 增</button>
          <button class="common-empty-button" @click="handleCommand()">导 出</button>
        </div>
          
        
      </div>
      <div class="wlplat-el-tb">
        <el-table :data="listData" :stripe="true" class="list_tb" border>
            <el-table-column prop="yearMon" label="结算周期" min-width="140" align="center" />
            <el-table-column prop="chargeElecAll" label="订单总电量" min-width="120" align="center" />
            <el-table-column prop="ammeterElecAll" label="电表总电量" min-width="120" align="center" />
            <el-table-column prop="peakAmmeter" label="峰电度数" min-width="160" align="center" />
            <el-table-column prop="peakElecFee" label="峰电金额" min-width="160" align="center" />
            <el-table-column prop="valleyAmmeter" label="谷电度数" min-width="160" align="center" />
            <el-table-column prop="valleyElecFee" label="谷电金额" min-width="160" align="center" />
            <el-table-column prop="createdWhen" label="录入时间" min-width="160" align="center" />
            <el-table-column prop="createdByName" label="录入人" min-width="160" align="center" />
            <el-table-column prop="createdWhen" sortable label="操作" min-width="160" align="center">
              <template slot-scope="scope">
                <el-button size="small" @click="handleEdit(scope.row)">编 辑</el-button>
                <!-- <el-button size="small" @click="handleDel(scope.row)">删 除</el-button> -->
              </template>
            </el-table-column>
        </el-table>
      
        <!--分页区-->
        <div class="list-pagination">
          <ZD-pagination :pagination="pagination" v-on:pageUpdate="initList"></ZD-pagination>
        </div>
      </div>
      
      <!-- 新增、编辑 边表电费记录 -->
      <el-dialog :title="editTabstitle" :visible.sync="editTabsVisible" width="48%" @close="reset">
          <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="电表名称：">
              <el-input v-model="formData.elecName" autocomplete="off" placeholder="请输入电表名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="电表户号：" prop="accountNo">
              <el-input v-model="formData.accountNo" autocomplete="off" placeholder="请输入电表户号"
                        onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="结算周期：">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM" v-model="formData.yearMon" type="month"
                              size="small" placeholder="请选择自然月"></el-date-picker>
            </el-form-item>
            <el-form-item label="峰电度数：">
              <el-input size="small" style="width: 100%;" v-model="formData.peakAmmeter" placeholder="请输入峰电度数" clearable></el-input>
            </el-form-item>
            <el-form-item label="峰电金额：">
              <el-input size="small" style="width: 100%;" v-model="formData.peakElecFee" placeholder="请输入峰电金额" clearable></el-input>
            </el-form-item>
            <el-form-item label="峰电表数：">
              <el-input size="small" style="width: 100%;" v-model="formData.peakElectricityTable" placeholder="请输入峰电表数" clearable></el-input>
            </el-form-item>
            <el-form-item label="谷电度数：">
              <el-input size="small" style="width: 100%;" v-model="formData.valleyAmmeter" placeholder="请输入谷电度数" clearable></el-input>
            </el-form-item>
            <el-form-item label="谷电金额：">
              <el-input size="small" style="width: 100%;" v-model="formData.valleyElecFee" placeholder="请输入谷电金额" clearable></el-input>
            </el-form-item>
            <el-form-item label="谷电表数：">
              <el-input size="small" style="width: 100%;" v-model="formData.valleyElectricityTable" placeholder="请输入谷电表数" clearable></el-input>
            </el-form-item>
            <el-form-item
              label="照片附件："
              prop="wxCode"
              class="detail-form-list long"
            >
              <el-upload
                action="#"
                name="file"
                ref="wxCodeFile"
                accept=".jpg, .jpeg, .png"
                list-type="picture-card"
                :limit="1"
                :file-list="formData.wxCodeList"
                :on-preview="handlePictureCardPreview"
                :on-exceed="handleExceed"
                :before-upload="handleBeforeUpload"
                :http-request="handleWxCodeUpload"
                :on-remove="handleWxCodeRemove"
              >
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="page-action-btns">
            <el-button class="common-bg-button" @click="submitForm('ruleForm')">确 定</el-button>
            <el-button class="common-empty-button" @click="reset('ruleForm')">取消</el-button>
          </div>
        </el-dialog>
       <!-- 图片弹出框 -->
    <el-dialog
      class="map-dailog-container"
      :visible.sync="imgPopup.show"
      :modal-append-to-body="false"
    >
      <img width="100%" :src="imgPopup.imageUrl" alt="" />
    </el-dialog>
   
    </div>
  </div>
</template>

<script>
    import pageConfig from "./page-config";
    // 系统配置文件
    import config from "@/config/configLog.js";
    import util from "@/common/util.js";

    export default {
        data() {
            return {
              stationFlag:true,
              exportDialogVisible:false,
              imgPopup: {
                show: false,
                imageUrl: "",
              },
                pageConfig: pageConfig, // 页面配置
                pagination: pageConfig.pagination,
                
                editableTabsValue: "0",
                tabIndex: 1,
                pickerOptions: {
                    //修改el-date-picker的时间
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                
                listData: [], // 列表数据
                editableTabs: [], // 电表 tabs
                // 数据列表查询
                queryInfo: {
                    elecName: '',
                    elecNo: '',
                    stationNo: '',
                    stationName: '',
                    yearMon: '',
                    pageNum: 0,
                    pageSize: 10
                },
                // 电表电费数据（新增、编辑）
                formData: {
                    elecName: '',
                    accountNo: '',
                    yearMon: '',
                    peakAmmeter: '',
                    peakElecFee: '',
                    peakElectricityTable:'',
                    valleyAmmeter: '',
                    valleyElecFee: '',
                    valleyElectricityTable:''
                },
                rules: {
                    accountNo: [
                        { required: true, message: '请输入电表户号', trigger: 'blur' }
                    ],
                }, // 验证
                
                monthList: [], // 月份总和
                // 弹出框
                editTabstitle: '',
                editTabsVisible: false,
            };
        },
        mounted() {
        // let arr = ['1','1','2','2','3','4','5','6'];
        
            this.init();
        },
        methods: {
          
           /* 图片预览 */
            handlePictureCardPreview(file) {
              this.imgPopup.imageUrl = file.url;
              this.imgPopup.show = true;
            },
             /* 文件超出个数限制 */
            handleExceed() {
              this.$message.error("当前限制选择 1 个文件");
            },
              /* 上传文件之前 */
            handleBeforeUpload(file) {
              let isLt1M = file.size / 1024 / 1024 < 1;
              if (!isLt1M) {
                this.$message.error("上传图片大小不能超过 1M!");
                return false;
              }
              return true;
            },
             /* 小程序码 */
            handleWxCodeUpload(response) {
              this.formData.file = [response.file];
              console.log(this.formData.file);
            },
            handleWxCodeRemove(file, fileList) {
              this.formData.file = fileList;
              this.formData.wxCodeList = fileList;
            },
            // 初始化
            init() {
                let _ = this;
                _.queryInfo.stationNo = _.$route.query.stationNo;
                _.queryInfo.stationName = _.$route.query.stationName;
                _.getListElecName();
            },
            // 获取tabs列表
            getListElecName() {
                let _ = this;
                _.$U.showLoading(_);
                _.$H.post(_, _.$A.ammeterFeeRecord.listElecName, { stationNo: _.queryInfo.stationNo }).then((res) => {
                    _.$U.hideLoading(_);
                    _.editableTabs = res.data.data || [];
                    if(_.editableTabs.length == 0){
                        _.editableTabs.push({elecName: '电表', elecNo: ''});
                    }
                    _.queryInfo.elecName = _.editableTabs[Number(_.editableTabsValue)].elecName;
                    _.queryInfo.elecNo = _.editableTabs[Number(_.editableTabsValue)].elecNo;
                    _.queryInfo.accountNo = _.editableTabs[Number(_.editableTabsValue)].accountNo;
                    _.initList(_.pagination, true);
                });
                // 上上月 上月 本月  总和
                _.$H.post(_, _.$A.ammeterFeeRecord.month, { stationNo: _.queryInfo.stationNo}).then((res) => {
                    _.monthList = res.data.data || [];
                });
            },
            // 页面初始化
            initList(pagination, reload = false) {
                // 列表查询渲染
                var _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                // 表格数据
                _.$H.post(_, _.$A.ammeterFeeRecord.page, JSON.stringify(_.queryInfo)).then((res) => {
                    let list = res.data.data.content || [];
                    if (list.length != 0){
                        _.listData = list.filter(item => item.elecNo == _.queryInfo.elecNo)
                    } else {
                        _.listData = list;
                    }
                    _.pagination.total = _.listData.length;
                    _.$U.hideLoading(_);
                });

                
            },
            
            // tabs 切换
            tabFlag(val, $event) {
                let _ = this
                if (val.label) {
                    _.queryInfo.elecName = val.label;
                    _.queryInfo.elecNo = _.editableTabs[val.index].elecNo;
                    _.queryInfo.accountNo  = _.editableTabs[val.index].accountNo;
                }
                _.initList(_.pagination, true);
            },
            beforeLeave(currentName, oldName) {
                var self = this;
                // 重点，如果name是add，则什么都不触发
                if (currentName == "add") {
                    this.addTab();
                    return false;
                } else {
                    this.tabIndex = currentName;
                }
            },
            // 添加tabs
            addTab(targetName) {
                let _ = this;
                _.$U.showLoading(this);
                let a = _.editableTabs.length;
                _.editableTabsValue = a + "";
                _.queryInfo.elecName = "电表";
                _.queryInfo.elecNo = "";
                _.editableTabs.push({
                    elecName: "电表",
                    elecNo: '',
                });
                _.initList(_.pagination, true);
            },
            
            // 导出
            handleCommand() {
                let _ = this;
                _.$U.showLoading(_);
                let params = {
                    elecName: _.queryInfo.elecName,
                    stationNo: _.queryInfo.stationNo,
                    stationName: _.queryInfo.stationName
                }
                _.$H.post(_, _.$A.ammeterFeeRecord.export, params).then((res) => {
                    _.$U.hideLoading(_);
                    let filePath = res.data.data.filePath;
                    // var downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
                    var downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
                    window.open(downUrl, "_blank");
                });
            },
            
            // 新增
            listAddFun(){
              let _ = this;
              _.formData = {
                  elecName: _.queryInfo.elecName,
                  elecNo: _.queryInfo.elecNo,
                  stationNo: _.queryInfo.stationNo,
                  stationName: _.queryInfo.stationName,
                  accountNo: _.queryInfo.accountNo,
                  yearMon: '',
                  peakAmmeter: '',
                  peakElecFee: '',
                  sharpAmmeter: '',
                  sharpElecFee: '',
                  wxCodeList:[]
              }
              _.editTabstitle = '新增电表电费数据';
              _.editTabsVisible = true;
            },
            // 重置
            resetList(){
                let _ = this;
                _.queryInfo.yearMon = '';
                _.initList(_.pagination, true);
            },

            // 新增、编辑 提交 电表数据
            submitForm(formName) {
                let _ = this;
                _.$refs[formName].validate((valid) => {
                    if(valid){
                        _.$U.showLoading(_);
                        if(_.editTabstitle == '新增电表电费数据'){
                          let formData = new FormData();
                          // Object.keys(_.formData).forEach((key) => {
                          //   // console.log(_.formData[key]);
                          //   // if(key == 'picturePath'){
                          //   //   formData.append(key, _.formData[key][0]);
                          //   // }
                          //   formData.append(key, _.formData[key]);
                          // });
                          formData.append('elecNo', _.formData.elecNo?_.formData.elecNo:'');
                          
                          formData.append('elecName', _.formData.elecName?_.formData.elecName:'');
                          formData.append('stationNo', _.formData.stationNo?_.formData.stationNo:'');
                          formData.append('stationName', _.formData.stationName?_.formData.stationName:'');
                          formData.append('accountNo', _.formData.accountNo?_.formData.accountNo:'');
                          formData.append('yearMon', _.formData.yearMon?_.formData.yearMon:'');
                          formData.append('peakAmmeter', _.formData.peakAmmeter?_.formData.peakAmmeter:'');
                          formData.append('peakElecFee', _.formData.peakElecFee?_.formData.peakElecFee:'');
                          formData.append('peakElectricityTable', _.formData.peakElectricityTable?_.formData.peakElectricityTable:'');
                          // formData.append('sharpAmmeter', _.formData.sharpAmmeter);
                          formData.append('valleyAmmeter', _.formData.valleyAmmeter?_.formData.valleyAmmeter:'');
                          formData.append('valleyElecFee', _.formData.valleyElecFee?_.formData.valleyElecFee:'');
                          // formData.append('sharpElecFee', _.formData.sharpElecFee);
                          formData.append('valleyElectricityTable', _.formData.valleyElectricityTable?_.formData.valleyElectricityTable:"");
                          // console.log(_.formData.file[0]);
                          formData.append("file", _.formData.file?_.formData.file[0]:null);
                          console.log(formData);
                            _.$H.post(_, _.$A.ammeterFeeRecord.add, formData).then((res) => {
                                _.$U.hideLoading(_);
                                _.editTabsVisible = false;
                                _.getListElecName();
                                _.$message.success("添加成功");
                                 _.formData.picturePath = [];
                                 _.formData.wxCodeList = [];
                            });
                        }
                        
                        if(_.editTabstitle == '编辑电表电费数据'){
                          
                          let formData = new FormData();
                          formData.append('elecNo', _.queryInfo.elecNo?_.queryInfo.elecNo:'');
                          formData.append('recordId', _.formData.recordId?_.formData.recordId:'');
                          // formData.append('elecName', _.formData.elecName);
                          formData.append('elecName', _.formData.elecName?_.formData.elecName:'');
                          formData.append('stationNo', _.formData.stationNo?_.formData.stationNo:'');
                          formData.append('stationName', _.formData.stationName?_.formData.stationName:'');
                          formData.append('accountNo', _.formData.accountNo?_.formData.accountNo:'');
                          formData.append('yearMon', _.formData.yearMon?_.formData.yearMon:'');
                          formData.append('peakAmmeter', _.formData.peakAmmeter?_.formData.peakAmmeter:'');
                          formData.append('peakElecFee', _.formData.peakElecFee?_.formData.peakElecFee:'');
                          formData.append('peakElectricityTable', _.formData.peakElectricityTable?_.formData.peakElectricityTable:'');
                          formData.append('valleyAmmeter', _.formData.valleyAmmeter?_.formData.valleyAmmeter:'');
                          formData.append('valleyElecFee', _.formData.valleyElecFee?_.formData.valleyElecFee:'');
                          // formData.append('sharpAmmeter', _.formData.sharpAmmeter);
                          // formData.append('sharpElecFee', _.formData.sharpElecFee);
                          formData.append('valleyElectricityTable', _.formData.valleyElectricityTable?_.formData.valleyElectricityTable:'');
                          formData.append('picturePath', _.formData.picturePath?_.formData.picturePath:'');
                          formData.append('chargeElecAll', _.formData.chargeElecAll?_.formData.chargeElecAll:'');
                          formData.append('chargeFeeAll', _.formData.chargeFeeAll?_.formData.chargeFeeAll:'');
                          console.log(_.formData);
                          // if(_.formData.file){
                            formData.append("file",_.formData.file?_.formData.file[0]:null);
                          // }else{
                            // formData.append("picturePath",_.formData.picturePath);
                          // }
                          
                            _.$H.post(_, _.$A.ammeterFeeRecord.edit, formData).then((res) => {
                                _.$U.hideLoading(_);
                                _.editTabsVisible = false;
                                _.getListElecName();
                                _.$message.success("编辑成功");
                            });
                        }
                        
                    }
                });
                
            },

            // 编辑
            handleEdit(row) {
                let _ = this;
                _.formData = row;
                _.formData.wxCodeList = []
                _.formData.wxCodeList.push({
                  name:'file',
                  url:'http://ocharge.shzhida.com:6777' +row.picturePath
                  // url:'http://192.168.8.174:7999' +row.picturePath
                })
                console.log(_.formData.wxCodeList);
                _.editTabstitle = '编辑电表电费数据';
                _.editTabsVisible = true;
            },

            // 删除
            handleDel(row) {
                let _ = this;
                this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    var listUrl = config.baseUrl + _.$A.ammeterFeeRecord.del + "/" + row.recordId;
                    _.$H.get(_, listUrl).then((res) => {
                        _.initList(_.pagination, true);
                        _.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                    });
                }).catch(() => {
                    _.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
            },

            // 新增、编辑 取消
            reset(formName) {
                let _ = this;
                _.editTabsVisible = false;
                _.formData = {
                    elecName: '',
                    accountNo: '',
                    yearMon: '',
                    peakAmmeter: '',
                    peakElecFee: '',
                    sharpAmmeter: '',
                    sharpElecFee: ''
                };
                if(formName){
                  _.$refs[formName].resetFields();
                }
            },
        },
        
    };
</script>
